module.exports = __webpack_public_path__ + "img/bh.f089a344.svg";